<template>
  <div class="benefits_holder">
    <p class="benefits_item benefits_item__prem-mk" id="benefits_item__prem" @mouseover="onTrackHover">
      {{ $t('30 дней премиум аккаунта в подарок') }}
    </p>
    <p class="benefits_item benefits_item__dublons" id="benefits_item__dublons" @mouseover="onTrackHover">
      {{ $t('25 золота за каждые потраченные 100 RUB') }}
    </p>
    <p class="benefits_item benefits_item__farm-dublons" id="benefits_item__farm-dublons" @mouseover="onTrackHover">
      {{ $t('5% от стоимости покупок в Премиум магазине и Адмиралтействе в виде золота') }}
    </p>
  </div>
</template>

<script>
import { Component } from 'vue-property-decorator'
import BenefitsBase from '../BenefitsBase.vue'

@Component
class BenefitsMtRu extends BenefitsBase {
}

export default BenefitsMtRu
</script>
